export const CONSUMABLES_MODULE_NAME = "consumables";
